import Cookie from "js-cookie";

// 登录态持久化：APP 冷启动不应反复登录；token 真失效时由接口层 401 兜底回登录页
const COOKIE_OPTS = { expires: 30 };
export default {
  state: {
    token: "",
    nickName: "",
    customer_id: "",
    roleCode: "",
    aliSTS: "",
    user_id: "",
  },
  mutations: {
    setSTS(state, val) {
      state.aliSTS = val;
    },
    setCustomerId(state, val) {
      state.customer_id = val;
    },
    setToken(state, val) {
      state.token = val;
      Cookie.set("token", val, COOKIE_OPTS);
    },
    clearToken(state) {
      state.token = "";
      Cookie.remove("token");
    },
    getToken(state) {
      state.token = Cookie.get("token");
    },
    setUser(state, val) {
      state.nickName = val;
      Cookie.set("nickName", val, COOKIE_OPTS);
    },
    getUser(state) {
      state.nickName = Cookie.get("nickName");
    },
    setUserId(state, val) {
      state.user_id = val;
      Cookie.set("user_id", val, COOKIE_OPTS);
    },
    getUserId(state) {
      state.user_id = Cookie.get("user_id");
    },
    setRole(state, val) {
      state.roleCode = val;
      Cookie.set("roleCode", val, COOKIE_OPTS);
    },
    getRole(state) {
      state.roleCode = Cookie.get("roleCode") || "";
    },
    clearAll(state) {
      state.token = "";
      state.nickName = "";
      state.roleCode = "";
      state.user_id = "";
      state.customer_id = "";
      Cookie.remove("token");
      Cookie.remove("nickName");
      Cookie.remove("roleCode");
      Cookie.remove("user_id");
    },
  },
  actions: {},
};
